import { GAME_FONT, MENU_TEXT_PRIMARY, MENU_TEXT_SECONDARY, mFont } from "../renderConstants";

export interface AboutContentDeps {
  ctx: CanvasRenderingContext2D;
  aboutHeadLogoImage: HTMLImageElement | null;
  aboutWordmarkLogoImage: HTMLImageElement | null;
}

export interface AboutContentOptions {
  centerX: number;
  topY: number;
  maxWidth: number;
  bodyFontPx: number;
  bodyLineHeight: number;
  bodyColor?: string;
  logoGapY: number;
  logoInlineGap: number;
  headMaxHeight: number;
  wordmarkMaxHeight: number;
  fallbackFontPx: number;
  fallbackColor?: string;
}

const ABOUT_LINES = [
  "A game made by 2 beasts.",
  "Keff Joons & Rafsby.",
] as const;

export function drawAboutContent(
  deps: AboutContentDeps,
  options: AboutContentOptions,
): number {
  const {
    ctx,
    aboutHeadLogoImage,
    aboutWordmarkLogoImage,
  } = deps;
  const bodyColor = options.bodyColor ?? MENU_TEXT_PRIMARY;
  const fallbackColor = options.fallbackColor ?? MENU_TEXT_SECONDARY;

  ctx.fillStyle = bodyColor;
  ctx.font = `bold ${options.bodyFontPx}px ${GAME_FONT}`;
  ctx.textAlign = "center";
  ctx.textBaseline = "top";

  let currentY = options.topY;
  for (const line of ABOUT_LINES) {
    ctx.fillText(line, options.centerX, currentY);
    currentY += options.bodyLineHeight;
  }

  const logoTopY = currentY + options.logoGapY;
  const logoHead = aboutHeadLogoImage;
  const logoWordmark = aboutWordmarkLogoImage;

  if (logoHead != null && logoWordmark != null) {
    let headH = options.headMaxHeight;
    let wordmarkH = options.wordmarkMaxHeight;
    let headW = Math.max(1, headH * ((logoHead.naturalWidth || 1) / (logoHead.naturalHeight || 1)));
    let wordmarkW = Math.max(1, wordmarkH * ((logoWordmark.naturalWidth || 1) / (logoWordmark.naturalHeight || 1)));
    let inlineGap = options.logoInlineGap;
    const totalW = headW + inlineGap + wordmarkW;
    if (totalW > options.maxWidth) {
      const scale = options.maxWidth / totalW;
      headH *= scale;
      wordmarkH *= scale;
      headW *= scale;
      wordmarkW *= scale;
      inlineGap *= scale;
    }

    const logoBlockW = headW + inlineGap + wordmarkW;
    const logoBlockH = Math.max(headH, wordmarkH);
    const startX = Math.round(options.centerX - logoBlockW / 2);
    const headY = Math.round(logoTopY + (logoBlockH - headH) / 2);
    const wordmarkY = Math.round(logoTopY + (logoBlockH - wordmarkH) / 2);

    ctx.drawImage(logoHead, startX, headY, Math.round(headW), Math.round(headH));
    ctx.drawImage(
      logoWordmark,
      Math.round(startX + headW + inlineGap),
      wordmarkY,
      Math.round(wordmarkW),
      Math.round(wordmarkH),
    );
    return logoTopY + logoBlockH;
  }

  ctx.fillStyle = fallbackColor;
  ctx.font = mFont("bold", options.fallbackFontPx);
  ctx.fillText("BEAST STUDIO LABS", options.centerX, logoTopY + 4);
  return logoTopY + options.bodyLineHeight;
}
